<template>
    <el-container height="auto">
      <el-aside width="250px" style="border-right: 0px solid #e7e9eb;
      position: relative;
      outline: none;
      color: #767c85;">
       <div>
          <el-table 
          v-loading="loading"
          ref="answerTable" :data="answerList" :show-header="false" @row-click="showAnswer" highlight-current-row>
            <!-- <el-table-column label="操作"  prop="scope.row.answerid" width="40">
              <template slot-scope="scope">
                <el-link v-if="scope.row.starflag=='1'" icon="el-icon-star-on" @click.stop="flagStar(scope.row.answerid)" :underline="false" style="font-size:20px;padding-right:8px;color:#E6A23C;"></el-link>
                <el-link v-if="scope.row.starflag!='1'" icon="el-icon-star-off" @click.stop="flagStar(scope.row.answerid)" :underline="false" style="font-size:20px;padding-right:8px;"></el-link>
              </template>
            </el-table-column> -->
            <el-table-column label="#" type="index" show-overflow-tooltip width="40">
            </el-table-column>
            <el-table-column label="名称"  prop="scope.row.createddate">
              <template slot-scope="scope">
                <span v-text="scope.row.createddate"></span>
              </template>
            </el-table-column>
            <el-table-column label="操作"  prop="scope.row.answerid" width="40">
              <template slot-scope="scope">
                <el-link v-show="form.answerid==scope.row.answerid" icon="el-icon-delete" @click.stop="deleteAnswer(scope.row.answerid)" :underline="false" style="font-size:20px;padding-right:8px"></el-link>
              </template>
            </el-table-column>
          </el-table>
          
        </div>

      </el-aside>
      <el-main style="margin:0px;padding:0px;padding-left:20px;overflow:hidden;">
          <el-container style="margin:0px;padding:0px;">
            <el-header style="height:50px;">
              <el-row type="flex" align="middle">
                <el-col>
                    <div>
                      <el-button @click="newForm">新建</el-button>
                      <el-button type="primary" @click="onSave">保存</el-button>
                      <span v-if="this.form.modifieddate || '' != ''"
                        style="font-size:14px;"
                      >
                        最后更新于 {{this.form.modifieddate}}
                        <span style="color:#aabbcc">{{$moment(this.form.modifieddate).fromNow()}}</span>
                      </span>
                    </div>
                </el-col>
                <el-col style="text-align:right">
                  
                    <el-link v-if="this.form.answerid!=0" :underline="false" @click="openVersion"><i class="fa fa-history"></i>&nbsp;历史数据</el-link>

          
                </el-col>
              </el-row>
               

               
            </el-header>
            <el-main style="margin:0px;padding:0px;padding-top:5px;overflow:hidden;">
                <el-drawer
                  title="查看历史版本"
                  size = "60%"
                  direction ="rtl"
                  :visible.sync="drawerversion"
                  :with-header="false"
                >

                      <el-table
                        v-loading="loadinghistory"
                        :data="history"
                        highlight-current-row
                        @row-click="history_rowclick"
                        style="width:100%"
                        max-height="200"
                      >
                        <el-table-column
                          label=""
                          type="index"
                          :index="indexMethod">
                        </el-table-column>
                        <el-table-column prop="createddate" label="时间" >
                          <template slot-scope="scope">
                            {{scope.row.createddate}}&nbsp;
                            <span style="color:#aabbcc">{{$moment(scope.row.createddate).fromNow()}}</span>
                            
                          </template>
                          
                        </el-table-column>
                        <el-table-column prop="username" label="最近" width="100px">
                        </el-table-column>
                        <el-table-column prop="operation" label="操作" >
                          <i class="fa fa-eye"></i>&nbsp;点击查看
                        </el-table-column>
                      </el-table>
                      <br>
                  <iframe ref="iframeversion" :src="viewVersionUrl" frameborder="0" scrolling="yes" name="iframeversion" seamless>您的浏览器版本过低，无法显示报表内容！建议升级浏览器或更换浏览器！</iframe>
                </el-drawer>

                <iframe ref="iframe" :src="viewUrl" frameborder="0" scrolling="yes" name="iframe" seamless>您的浏览器版本过低，无法显示报表内容！建议升级浏览器或更换浏览器！</iframe>
            </el-main>
          </el-container>
      </el-main>
  </el-container>
</template>
<script>
  export default {
    data() {
      return {
        answerList: [],
        loading:true,
        loadinghistory:true,
        viewUrl: '',
        form: {
          formid: this.$route.query['id'],
          answerid: '',
          xmlresult: ''
        },

        rules: {
        },
        history:[],
        drawerversion:false,
        viewVersionUrl:'',
      }
    },
    mounted() {
      this.loadList();
      this.loadForm();
    },
    methods: {
      loadList() {
            this.loading = true;
            this.$http.get('form/answers',{params:{id:this.form.formid}}).then((res) => {
              if(!res) return;
              this.answerList = res.data.list;
              this.loading = false;

              //选中行
              for(var i=0; i<this.answerList.length; i++)
              {
                if(this.answerList[i].answerid== this.form.answerid)
                {
                  this.$refs.answerTable.setCurrentRow(this.answerList[i]);
                }
              }
              
              });                                                  
        },
        showAnswer(row, col, evt) {
          this.loadVersionList(row.answerid);
          this.$http.get('form/showanswer',{params:{id:row.answerid,subjectid:0}}).then((res) => {
              if(!res) return;
              
              this.form.answerid = res.data.answer.answerid;
              this.form.modifieddate = res.data.answer.modifieddate;
              //this.form.id = res.data.form.formid;

              var view = res.data.view;
              window.formViewHtml = view;
              this.viewUrl = 'formviewer/index.html?timer=' + (new Date()).getTime();
              }); 
              
        },
        loadVersionList(answerid){
          this.loadinghistory = true;
         this.$http.get('form/answerversions',{params:{answerid:answerid}})
         .then(res=>{
            if(!res)return;
            this.history = res.data.list;

            this.viewVersionUrl ='';
            this.loadinghistory = false;

         })
      },

        newForm(){
          //
          this.$refs.answerTable.setCurrentRow(null);
          this.loadForm();
        },

        deleteAnswer(answerid){
        this.$confirm("确定要删除数据吗？", '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
            }).then(() => {
                this.$http.post('form/deleteanswer', {'answerid':answerid}).then((res) => { 
                this.loadList();
                  }); 
            }, ()=>{});
      },
      flagStar(answerid){
        this.$http.post('form/flagstar', {'answerid':answerid}).then((res) => { 
                this.loadList();
                  }); 
      },

      onSave(){
          //var str = this.$refs.iframe.contentWindow.Save();
          //var formContent = JSON.parse(str);
          var str = this.$refs.iframe.contentWindow.Save();
          console.log(str)
         
          this.form.result = str;
          this.$http.post('form/saveanswer', this.form).then((res) => {
              if(!res) return;

              //提醒成功
              this.$message({ type:'success', message:'保存成功'})
              console.log(res.data)
              //重新加载路由
              this.form.answerid = res.data.info["answerid"]
              //this.form.id = res.data.form["formid"]
              this.loadList();
              this.loadVersionList(this.form.answerid);
            
          }); 
      },
      onSubmit() {
        this.$refs['form'].validate((valid) => {
          if (valid) {
            
              this.$http.post('form/edit', this.form).then((res) => {
                  if(!res) return;

                  //提醒成功
                  this.$message({ type:'success', message:'保存成功'})
                  
                  //清除内容
                  this.form = res.data.info;
              }); 


          } else {
            this.$message({ type:'error', message:'请按指示完成填写'})
            return false;
          }
        });
      },
      loadForm(){
        this.form.answerid = '0';
        this.form.xmlresult= '';
        this.$http.get('form/view', {params:{id:this.form.formid}}).then((res) => { 
            if(!res) return;

            var view = res.data.view;


                window.formViewHtml = view;
                this.viewUrl = 'formviewer/index.html?timer=' + (new Date()).getTime();
              }); 
      },

      indexMethod(index) {
        return this.history.length-index;
      },
      openVersion(){
        this.drawerversion = true;
      },
      history_rowclick(row,event,column){
        this.$http.get('form/showanswerversion',{params:{id:row.indexid,subjectid:0}}).then((res) => {
          if(!res) return;

          var view = res.data.view;
          window.formViewHtml = view;
          this.viewVersionUrl = 'formviewer/index.html?timer=' + (new Date()).getTime();
          }); 
      },
     
    }
  }
</script>

<style scoped>
iframe {
  width:100%;
  height:100%;
}
</style>